'use client'
const isPendingWalletRequestPermissionError = (error) => typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    error.message.includes("Request of type 'wallet_requestPermissions' already pending for origin");

export { isPendingWalletRequestPermissionError };
